/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SharedInsightLoginInput = {|
  uuid: string,
  password: string,
  clientMutationId?: ?string,
|};
export type sharedInsightLoginMutationVariables = {|
  input: SharedInsightLoginInput
|};
export type sharedInsightLoginMutationResponse = {|
  +sharedInsightLogin: ?{|
    +viewer: ?{|
      +id: string
    |},
    +errors: ?$ReadOnlyArray<?string>,
  |}
|};
export type sharedInsightLoginMutation = {|
  variables: sharedInsightLoginMutationVariables,
  response: sharedInsightLoginMutationResponse,
|};
*/


/*
mutation sharedInsightLoginMutation(
  $input: SharedInsightLoginInput!
) {
  sharedInsightLogin(input: $input) {
    viewer {
      id
    }
    errors
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SharedInsightLoginInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SharedInsightLoginPayload",
    "kind": "LinkedField",
    "name": "sharedInsightLogin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sharedInsightLoginMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sharedInsightLoginMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "sharedInsightLoginMutation",
    "operationKind": "mutation",
    "text": "mutation sharedInsightLoginMutation(\n  $input: SharedInsightLoginInput!\n) {\n  sharedInsightLogin(input: $input) {\n    viewer {\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd7a897065c483d7f2fc765e2f67aeeb6';

module.exports = node;
